const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Returns the ordinal suffix ("st", "nd", "rd", "th") for a given day-of-month number.
 */
export function getOrdinalSuffix(day: number): string {
  const j = day % 10;
  const k = day % 100;
  if (j === 1 && k !== 11) return 'st';
  if (j === 2 && k !== 12) return 'nd';
  if (j === 3 && k !== 13) return 'rd';
  return 'th';
}

/**
 * Formats an ISO date string as "Month Dayth" (e.g. "July 9th"), used for the
 * "Questions will be posted <date>" copy in the Reserve a Seat flow (DKPLAT-528).
 * Uses UTC date parts so every user sees the calendar date the admin configured,
 * regardless of their local timezone (local getters would show e.g. "July 8th"
 * for a ...-07-09T00:00:00Z timestamp to users behind UTC).
 * Returns null when the input is null/undefined/unparseable so callers can
 * decide whether to render the line at all.
 */
export function formatOrdinalDate(isoDate: string | null | undefined): string | null {
  if (!isoDate) return null;

  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return null;

  const month = MONTH_NAMES[date.getUTCMonth()];
  const day = date.getUTCDate();

  return `${month} ${day}${getOrdinalSuffix(day)}`;
}
